/** Stable hash id for FAQ category headings (e.g. /faq#motor-vehicle) */
export function faqCategoryId(category) {
  return category
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
